<template lang="pug">
.container
  page-header(
    :disable-back="true"
  )
  .page.detail-page
    h2 Foto-Album

    button.btn.btn-sm.btn-right(type="button" @click="currentImage--" v-if="currentImage != 1")  
      svg(xmlns="http://www.w3.org/2000/svg", viewBox="0 0 24 24")
        path(d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z")

    button.btn.btn-sm.btn-left(type="button" @click="currentImage++" v-if="currentImage != imageCount")
      svg(xmlns="http://www.w3.org/2000/svg", viewBox="0 0 24 24")
        path(d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z")

    .gallery: img(:src="require(`@/assets/img/gallery/img_${currentImage}.jpg`)")
    div(class="glide__bullets")
      button.glide__bullet(v-for="i in imageCount" :class="i == currentImage ? 'glide__bullet--active' : ''" @click="currentImage = i")
</template>

<script>
export default {
  data(){
    return {
      currentImage: 1,
      imageCount: 13
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.detail-page{
  height: calc(100% - 1000px);
}

@media (max-width: 896px) {
  .detail-page{
    height: 100%;
  }
}
</style>

